import { Box } from "@chakra-ui/react";
import { MotionBox } from "utils/motion";
import MoreIcon from "components/icons/MoreIcon";
import Image from "components/base/Image";
import Text from "components/base/Text";

const TeamMemberCard = ({ name, title, image, onClick, order }) => (
  <MotionBox
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    borderRadius="md"
    overflow="hidden"
    shadow="md"
    position="relative"
    onClick={onClick}
    cursor="pointer"
    _hover={{ ".zoom-image": { transform: "scale(1.05)" } }}
  >
    <Image
      className="zoom-image"
      src={image.url}
      alt={name}
      transition="transform 0.3s ease"
      objectFit="cover"
      height="100%"
      width="100%"
      minHeight="180px"
      maxHeight={
        order === 0
          ? ["350px", null, "450px", null, "550px"]
          : ["350px", null, "350px", null, "450px"]
      }
    />
    <Box
      p={[2, 2, 2, 4]}
      position="absolute"
      bottom={0}
      left={0}
      right={0}
      bg="linear-gradient(to bottom, rgba(0, 0, 0, 0) 2%, #000000);"
    >
      <Text type="title_lg" fontWeight="bold" lineHeight={1.5} color="white">
        {name}
      </Text>
      <Text type="title_xs" color="primary">
        {title}
      </Text>
    </Box>
    <Box
      display={["block", "none"]}
      p={[2]}
      position="absolute"
      top={0}
      left={0}
    >
      <MoreIcon />
    </Box>
  </MotionBox>
);

export default TeamMemberCard;
